module.exports = __webpack_public_path__ + "static/media/SparkDJ-Icon.8554a4c3.png";